import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { transformRecommendationsNearNewbuilding } from '../../../mappers/transformRecommendationsNearNewbuilding';

import {
  fetchGetRecommendationsNearNewbuilding,
  IGetRecommendationsNearNewbuildingResponse200,
  IGetRecommendationsNearNewbuildingResponse400,
} from '../../../repositories/newbuilding-search/v1/get-recommendations-near-newbuilding';

import { IRecommendationNewbuildingInfrastructure } from '../../../types/map';
import { ResponseError } from '../../../utils/errors';

export const getRecommendationNewbuildings = async (
  newbuildingId: number,
): Promise<IRecommendationNewbuildingInfrastructure[]> => {
  try {
    const response = await fetchGetRecommendationsNearNewbuilding<
      IGetRecommendationsNearNewbuildingResponse200,
      IGetRecommendationsNearNewbuildingResponse400
    >({
      httpApi: getHttpApi(),
      parameters: { newbuildingId },
      config: {
        requestConfig: { withCredentials: true },
      },
    });

    if (response.statusCode === 400) {
      const { message } = response.response;

      throw new ResponseError({
        domain: 'Map#getRecommendationNewbuildings()',
        message: message as string,
      });
    }

    return transformRecommendationsNearNewbuilding(response.response);
  } catch (error) {
    getLogger().error(error, {
      newbuildingId,
      domain: 'getRecommendationNewbuildings',
    });

    return [];
  }
};
